import {NgModule} from '@angular/core';
import {CommonModule, DatePipe, NgOptimizedImage} from '@angular/common';
import {ConfirmDialogComponent} from "./confirm-dialog/confirm-dialog.component";
import {ManageAccessComponent} from "./manage-access/manage-access.component";
import {ManageAccessTableComponent} from "./manage-access-table/manage-access-table.component";
import {MediaDisplayComponent} from "./media-display/media-display.component";
import {PdfViewerComponent} from "./pdf-viewer/pdf-viewer.component";
import {MemoriesSearchComponent} from "./memories-search/memories-search.component";
import {PasswordValidatorComponent} from "./password-validator/password-validator.component";
import {TimelineMultiSelectComponent} from "./timeline-multi-select/timeline-multi-select.component";
import {TimelineSearchComponent} from "./timeline-search/timeline-search.component";
import {UserSearchComponent} from "./user-search/user-search.component";
import {AlertBannerComponent} from "./alert-banner/alert-banner.component";
import {AudioPlayerComponent} from "./audio-player/audio-player.component";
import {FooterComponent} from "./footer/footer.component";
import {MatIconModule} from "@angular/material/icon";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatMenuModule} from "@angular/material/menu";
import {MatButtonModule} from "@angular/material/button";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatInputModule} from "@angular/material/input";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatCardModule} from "@angular/material/card";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatListItem, MatListModule, MatNavList} from "@angular/material/list";
import {
    MatDatepickerModule,
    MatDatepickerToggle,
    MatDateRangeInput,
    MatDateRangePicker
} from "@angular/material/datepicker";
import {MatSlideToggle} from "@angular/material/slide-toggle";
import {MatBadgeModule} from "@angular/material/badge";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatChipsModule} from "@angular/material/chips";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatDividerModule} from "@angular/material/divider";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatDialogModule} from "@angular/material/dialog";
import {MatTableModule} from "@angular/material/table";
import {MatTabsModule} from "@angular/material/tabs";
import {ImageCropperComponent} from "ngx-image-cropper";
import {MatSelectModule} from "@angular/material/select";
import {MatSliderModule} from "@angular/material/slider";
import {MatPaginator} from "@angular/material/paginator";
import {GreetingPipe} from "../_pipes/greeting.pipe";
import {EllipsisPipe} from "../_pipes/ellipsis.pipe";
import {MatSortModule} from "@angular/material/sort";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatStepperModule} from "@angular/material/stepper";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {PermissionsDisplayPipe} from "../_pipes/permissions-display.pipe";
import {NameDisplayPipe} from "../_pipes/name-display.pipe";
import {RemoveBracketsPipe} from "../_pipes/remove-brackets.pipe";
import {EmojiMenuComponent} from "./emoji-menu/emoji-menu.component";


const components = [
    ConfirmDialogComponent,
    ManageAccessComponent,
    ManageAccessTableComponent,
    MediaDisplayComponent,
    PdfViewerComponent,
    MemoriesSearchComponent,
    PasswordValidatorComponent,
    TimelineMultiSelectComponent,
    TimelineSearchComponent,
    UserSearchComponent
];

const modules = [
    GreetingPipe,
    EllipsisPipe,
    AlertBannerComponent,
    AudioPlayerComponent,
    FooterComponent,
    CommonModule,
    MatIconModule,
    MatToolbarModule,
    MatMenuModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatCardModule,
    MatProgressSpinner,
    MatSidenavModule,
    MatNavList,
    MatListItem,
    MatDateRangeInput,
    MatDatepickerToggle,
    MatDateRangePicker,
    MatDatepickerModule,
    MatSlideToggle,
    MatBadgeModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatExpansionModule,
    MatDividerModule,
    MatProgressBarModule,
    MatListModule,
    MatDialogModule,
    MatTableModule,
    MatTabsModule,
    ImageCropperComponent,
    MatSelectModule,
    MatSliderModule,
    MatPaginator,
    MatSortModule,
    MatCheckboxModule,
    MatStepperModule,
    MatButtonToggleModule,
    PermissionsDisplayPipe,
    NgOptimizedImage,
    NameDisplayPipe,
    DatePipe,
    RemoveBracketsPipe,
    EmojiMenuComponent
]


@NgModule({
    declarations: [
        ...components,
    ],
    imports: [
        CommonModule,
        ...modules,
    ],
    exports: [
        ...components,
        ...modules,
    ]
})
export class SharedModule {
}
